import { create } from "zustand";

export interface LembreteCalendario {
  id: string;            // chave única (eventoId + data)
  titulo: string;
  mensagem: string;
  tipo: string;          // tipo do evento (aniversario, feriado, etc)
  emoji: string;
  link?: string;         // URL pra abrir ao clicar (ex: /calendario)
  criadoEm: string;      // ISO
  lido: boolean;
}

interface LembretesState {
  lembretes: LembreteCalendario[];
  add: (l: Omit<LembreteCalendario, "lido">) => void;
  marcarLido: (id: string) => void;
  marcarTodosLidos: () => void;
  limpar: () => void;
}

const SS_KEY = "growsoft_lembretes_calendario";

function ler(): LembreteCalendario[] {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch { return []; }
}
function gravar(lembretes: LembreteCalendario[]) {
  try { sessionStorage.setItem(SS_KEY, JSON.stringify(lembretes)); } catch {}
}

export const useLembretesCalendarioStore = create<LembretesState>((set, get) => ({
  lembretes: ler(),
  add: (l) => {
    const atual = get().lembretes;
    if (atual.some((x) => x.id === l.id)) return;
    const novo = [{ ...l, lido: false }, ...atual].slice(0, 50);
    gravar(novo);
    set({ lembretes: novo });
  },
  marcarLido: (id) => {
    const novo = get().lembretes.map((l) => (l.id === id ? { ...l, lido: true } : l));
    gravar(novo);
    set({ lembretes: novo });
  },
  marcarTodosLidos: () => {
    const novo = get().lembretes.map((l) => ({ ...l, lido: true }));
    gravar(novo);
    set({ lembretes: novo });
  },
  limpar: () => {
    gravar([]);
    set({ lembretes: [] });
  },
}));
